import toast from 'reusable-components/notifications/toast';
import { create } from 'zustand';

type DebugModeState = {
  debugMode: boolean;
  setDebugMode: (newMode: boolean) => void;
};
export const useDebugModeStore = create<DebugModeState>()((set) => ({
  debugMode: false,
  setDebugMode: (newMode) => {
    toast({
      toastId: 'debug-mode-toast',
      text: `Debug mode is now ${newMode ? 'enabled' : 'disabled'}.`,
      position: 'bottom-center',
    });
    set({ debugMode: newMode });
  },
}));
